module.exports = __webpack_public_path__ + "img/logo-tb.a6212177.png";